<template>
	<div class="warning-center-new">
		<div class="container">
			<!-- 头部 -->
			<div class="header">
				<div class="title">预警中心</div>
			</div>

			<!-- Tabs -->
			<div class="tabs">
				<div class="tab-item" :class="{ active: currentTab === 'message' }" @click="currentTab = 'message'">
					消息提醒 ({{ messageTotalCount }})
					<div class="indicator" v-if="currentTab === 'message'"></div>
				</div>
				<div class="tab-item" :class="{ active: currentTab === 'todo' }" @click="currentTab = 'todo'">
					待办事项 ({{ todoList.length }})
					<div class="indicator" v-if="currentTab === 'todo'"></div>
				</div>
			</div>

			<!-- 内容列表 -->
			<div class="content">
				<transition name="fade" mode="out-in">
					<div class="card-list" v-if="currentTab === 'message'" key="message">
						<div class="card message-card" v-for="(item, index) in messageList" :key="index">
							<div class="icon-box">
								<img :src="item.icon" alt="" />
							</div>
							<div class="info-box">
								<div class="text" v-html="item.text"></div>
								<div class="link" @click="goDetail(item)">前往查看 ></div>
							</div>
						</div>
					</div>
					<div class="card-list" v-if="currentTab === 'todo'" key="todo">
						<div class="card todo-card" v-for="(item, index) in todoList" :key="index">
							<div class="icon-box">
								<img :src="item.icon" alt="" />
							</div>
							<div class="info-box">
								<div class="text" v-html="item.text"></div>
								<div class="link" @click="goDetail(item)">前往查看 ></div>
							</div>
						</div>
					</div>
				</transition>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		HomeRemindGetMessageCount,
		HomeRemindGetForWarningSimple
	} from "@/api/channel";

	export default {
		name: 'WarningCenterNew',
		data() {
			return {
				currentTab: 'message', // 默认选中消息提醒  
				messageTotalCount: 0,
				messageList: [{
						id: 1,
						text: '您有 <span style="color:#E71D43;font-weight:bold;">0条</span> 最新资讯待查看',
						icon: require('@/assets/warn/icon_yj_pic1_n@2x.png'),
						path: '/homeCom/Informationrelease?NodeID=66'
					},
					{
						id: 2,
						text: '您有 <span style="color:#E71D43;font-weight:bold;">0条</span> 最新数据待处理',
						icon: require('@/assets/warn/icon_yj_pic2_n@2x.png'),
						path: '/homeCom/EarlyWarningCcenter?NodeID=64'
					}
				],
				todoList: []
			}
		},
		mounted() {
			this.initData();
		},
		methods: {
			initData() {
				this.getMessageCount();
				this.getTodoWarning();
			},
			async getMessageCount() {
				try {
					const res = await HomeRemindGetMessageCount({});
					if (res && res.code === 0) {
						const data = res.data || {};
						this.messageTotalCount = (data.InfoCount || 0) + (data.WarningCount || 0);
						this.messageList[0].text =
							`您有 <span style="color:#E71D43;font-weight:bold;">${data.InfoCount || 0}条</span> 最新资讯待查看`;
						this.messageList[1].text =
							`您有 <span style="color:#E71D43;font-weight:bold;">${data.WarningCount || 0}条</span> 最新数据待处理`;
					}
				} catch (error) {
					console.error("获取消息提醒数量失败", error);
				}
			},
			async getTodoWarning() {
				try {
					const res = await HomeRemindGetForWarningSimple({});
					if (res && res.code === 0 && Array.isArray(res.data)) {
						this.todoList = res.data.map((item, index) => {
							// 循环使用图标 3-8
							const iconIndex = (index % 6) + 3;
							return {
								id: index,
								text: item.StringMessage,
								path: item.ViewUrl,
								icon: require(`@/assets/warn/icon_yj_pic${iconIndex}_n@2x.png`)
							};
						});
					}
				} catch (error) {
					console.error("获取待办事项失败", error);
				}
			},
			goDetail(item) {
				if (item.path) {
					this.$router.push(item.path);
				} else {
					console.log('未配置跳转路径', item);
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.warning-center-new {
		width: 100%;
		margin-bottom: 20px;

		.container {
			width: 100%;
			margin: 0 auto;
			background: #FFFFFF;
			border-radius: 4px;
			padding: 20px 0;
			box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		}

		.header {
			display: flex;
			justify-content: center;
			align-items: center;
			position: relative;
			margin-bottom: 20px;

			.title {
				font-size: 24px;
				font-weight: 500;
				color: #16181A;
			}

			.more {
				position: absolute;
				right: 20px;
				font-size: 14px;
				color: #666666;
				cursor: pointer;

				&:hover {
					color: #E71D43;
				}
			}
		}

		.tabs {
			display: flex;
			justify-content: center;
			border-bottom: 1px solid #EAECEF;
			margin-bottom: 30px;

			.tab-item {
				font-size: 16px;
				color: #999999;
				padding: 0 20px 10px;
				cursor: pointer;
				position: relative;
				margin: 0 30px;

				&.active {
					color: #E71D43;
					font-weight: 500;
				}

				.indicator {
					position: absolute;
					bottom: 0;
					left: 50%;
					transform: translateX(-50%);
					width: 100%;
					height: 3px;
					background: #E71D43;
					border-radius: 2px;
				}
			}
		}

		.content {
			padding: 0 30px;
			min-height: 200px;

			.card-list {
				display: flex;
				flex-wrap: wrap;
				gap: 20px;
			}

			.card {
				width: calc((100% - 40px) / 3); // 3列布局
				height: 100px;
				border-radius: 10px;
				display: flex;
				align-items: center;
				padding: 0 20px;
				box-sizing: border-box;
				transition: all 0.3s;
				cursor: pointer;
				border: 1px solid;

				&.message-card {
					background: linear-gradient(180deg, #FFF5F5 0%, #FFFFFF 100%);
					border: 1px solid rgba(255, 191, 191, 1);
				}

				&.todo-card {
					background: linear-gradient(180deg, #F0F5FF 0%, #FFFFFF 100%);
					border: 1px solid rgba(191, 212, 255, 1);
				}

				.icon-box {
					width: 60px;
					height: 60px;
					background: #FFFFFF;
					border-radius: 8px;
					margin-right: 15px;
					display: flex;
					justify-content: center;
					align-items: center;

					img {
						width: 40px;
						height: 40px;
						object-fit: contain;
					}
				}

				.info-box {
					flex: 1;

					.text {
						font-size: 16px;
						color: #333333;
						margin-bottom: 8px;
					}

					.link {
						font-size: 14px;
						color: #4472C4;
						cursor: pointer;

						&:hover {
							text-decoration: underline;
						}
					}
				}
			}
		}
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.3s;
	}

	.fade-enter,
	.fade-leave-to {
		opacity: 0;
	}
</style>